import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  state: false,
  value: 0,
};

const turboModeModalSlice = createSlice({
  name: "turboModeModal",
  initialState,
  reducers: {
    setTurboModeModal: (state, action) => {
      const { state: open, value } = action.payload || {};

      // state (open/close) uvek ažuriraj ako je prosleđen boolean
      if (typeof open === "boolean") state.state = open;

      // value menjaj SAMO ako je eksplicitno prosleđen
      if (value !== undefined) state.value = value;
    },
  },
});

export const { setTurboModeModal } = turboModeModalSlice.actions;
export default turboModeModalSlice.reducer;
